<div class="table-responsive" [class.overflow-hidden]="emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover directory-list-table footable">
        <thead>
            <tr [ngClass]="{'noSort': data.length < 2}">
                <th></th>
                <th (click)="orderBy('suite.suiteNumber', $event)" class="footable-sorted">
                    Unit<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="directoryService.buildings.length != 1 && !directoryService.showDetailedView"
                    (click)="orderBy('building.name', $event)">
                    Building<span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('user.fullName', $event)">
                    Full Name<span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('user.email', $event)">
                    Email<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!directoryService.showDetailedView"
                    (click)="orderBy('user.primaryPhone', $event)">
                    Phone<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!directoryService.showDetailedView"
                    (click)="orderBy('user.residentStatus', $event)">
                    Active<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!directoryService.showDetailedView && usingWaiverType('Parcels')"
                    (click)="orderBy('user.parcelWaiverSigned', $event)">
                    Parcel<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!directoryService.showDetailedView && usingWaiverType('Key')"
                    (click)="orderBy('user.keyWaiverSigned', $event)">
                    Keys<span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('role', $event)">
                    Type<span class="footable-sort-indicator"></span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of data" (click)="toggleCheck(item)"
                [attr.suite-user-id]="item.suiteUserId" [attr.user-id]="item.id" >
                <td>
                    <label class="img-checkbox">
                        <input type="checkbox" [ngModel]="item.checked">
                        <label><svg-checked></svg-checked></label>
                    </label>
                </td>
                <td>{{item.suiteNumber}}</td>
                <td *ngIf="directoryService.buildings.length != 1 && !directoryService.showDetailedView">
                    {{item.buildingName}}
                </td>
                <td class="full-name">
                    <div class="flex-wrap">
                        <labels-list [labelsList]="item.groups" keyName="itemName"></labels-list>
                        <span class="name"> {{item.fullName}}</span>
                    </div>
                </td>
                <td class="contact-type cutText emailTd" title="{{item.email}}">
                    <span>{{item.email}}</span>
                </td>
                <td *ngIf="!directoryService.showDetailedView" style="max-width: 100px;">
                    <span>{{getPrimaryPhone(item)}}</span>
                </td>
                <td *ngIf="!directoryService.showDetailedView" class="with-icon">
                    <i *ngIf="item.maxTvUser" class="icon-check"></i>
                    <i *ngIf="!item.maxTvUser && item.isInvited"><img src="../../../../../assets/img/pending.png"></i>
                    <i *ngIf="!item.maxTvUser && !item.isInvited" class="icon-close"></i>
                </td>
                <td *ngIf="!directoryService.showDetailedView && usingWaiverType('Parcels')" class="with-icon">
                    <i *ngIf="item.parcelWaiverSigned" class="icon-check"></i>
                    <i *ngIf="!item.parcelWaiverSigned" class="icon-close"></i>
                </td>
                <td *ngIf="!directoryService.showDetailedView && usingWaiverType('Key')" class="with-icon">
                    <i *ngIf="item.keyWaiverSigned" class="icon-check"></i>
                    <i *ngIf="!item.keyWaiverSigned" class="icon-close"></i>
                </td>
                <td>
                    <span [class]="'label ' + getLabelRole(item.role)?.class">{{getLabelRole(item.role)?.name}}</span>

                    <span *ngIf="directoryService.dateIsLaterThanCurrent(item.occupancyDate)"
                          title="{{item.occupancyDate | date: 'dd.MM.yyyy'}}"
                          class="label resident-label">
                        Move In
                    </span>
                    <span *ngIf="directoryService.dateIsLaterThanCurrent(item.moveOutDate)"
                          title="{{item.moveOutDate | date: 'dd.MM.yyyy'}}"
                          class="label resident-label">
                        Move Out
                    </span>
                    <span *ngIf="directoryService.dateIsEarlierThanCurrent(item.moveOutDate)"
                          title="{{item.moveOutDate | date: 'dd.MM.yyyy'}}"
                          class="label archived-item">
                        Archived
                    </span>
                </td>
            </tr>
            <tr *ngFor="let item of emptyRowService.emptyRow" style="cursor: default;">
                <td><div class="psevdo-checkbox"></div></td>
                <td></td>
                <td *ngIf="directoryService.buildings.length != 1 && !directoryService.showDetailedView"></td>
                <td></td>
                <td class="contact-type cutText emailTd" title="{{item.email}}"></td>
                <td *ngIf="!directoryService.showDetailedView" class="nowrap"></td>
                <td *ngIf="!directoryService.showDetailedView" class="nowrap"></td>
                <td *ngIf="!directoryService.showDetailedView && usingWaiverType('Parcels')"></td>
                <td *ngIf="!directoryService.showDetailedView && usingWaiverType('Key')"></td>
                <td></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message
            [isEmpty]="!directoryService.directoryData['residents'].total"
            [isServiceUnavailable]="directoryService.showServiceUnavailable"
            [isLoading]="directoryService.spinnerShow">
        You have no residents listed on the system<br>
        <span *ngIf="directoryService.account.canUpdate('bldn')">
            <a href="javascript://" (click)="directoryService.showModal()" class="mtv-primary-color clickable-text">add a resident</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/list/residents-list/residents-list.component.html